import i18n from '../../../utils/i18n';
import {
  BarChartDataSeries,
  BarChartGroup,
  healthScoreCombined,
  seriesGroupType,
} from '../graphTypes';

const valueToPerc = (valArray: number[]): number[] => {
  let total: number = 0;
  valArray.forEach((stat) => {
    total = total + stat;
  });
  const percArray: number[] = [];
  valArray.forEach((stat) => {
    percArray.push((stat / total) * 100);
  });
  return percArray;
};

export const statsToSeries = (
  seriesGroup: seriesGroupType[],
  statId: string,
  statName?: string,
): BarChartDataSeries => {
  const statsArray: number[] = [];
  const [sGrp] = seriesGroup;
  const [key] = Object.entries(sGrp);

  const statType: string = key[0] || 'error';
  Object.entries(sGrp[statType]).forEach((entry) => {
    const [, value] = entry;
    statsArray.push(value);
  });
  const percArray: number[] = valueToPerc(statsArray);

  return {
    id: statId,
    name: statName || statId,
    seriesType: statType,
    values: percArray,
  };
};

export const seriesToArray = (
  series: seriesGroupType[],
  statId: string,
  seriesType: string,
  statName?: string,
): BarChartDataSeries => {
  const statsArray: number[] = [];

  Object.entries(series).forEach((entry) => {
    const [, value] = entry;
    // @ts-ignore
    statsArray.push(value);
  });

  const percArray: number[] = valueToPerc(statsArray);

  return {
    id: statId,
    name: statName || statId,
    seriesType: seriesType,
    values: percArray,
  };
};

export const getHealthSummaryGroups = (): BarChartGroup[] => [
  {
    color: '#575BCF',
    key: 'myHealthScore',
    label: i18n.t('healthSummary.breakdown.myNetwork'),
    stroke: '#575BCF',
  },
  {
    color: '#81BB85',
    key: 'typicalHealthScore',
    label: i18n.t('healthSummary.breakdown.typNetwork'),
    stroke: '#81BB85',
  },
];

export const combineHealthChart = (
  partnerSeries: BarChartDataSeries,
  typicalSeries: BarChartDataSeries,
): healthScoreCombined[] => {
  const barSeries: healthScoreCombined[] = [];
  typicalSeries.values.forEach((val, key) => {
    barSeries.push({
      name: String(key * 5),
      values: [partnerSeries.values[key], typicalSeries.values[key]],
    });
  });
  return barSeries;
};

export const getHealthScoreData = (
  partnerStats: any,
  typicalStats: any,
): healthScoreCombined[] => {
  if (typicalStats && typicalStats[0] && partnerStats && partnerStats[0]) {
    let typicalStatsSeries: BarChartDataSeries = seriesToArray(
      typicalStats[0]['health_score_distribution'],
      'latest_typical_stats',
      'health_score_distribution',
      i18n.t('healthSummary.breakdown.typNetwork'),
    );
    let partnerStatsSeries: BarChartDataSeries = seriesToArray(
      partnerStats[0]['health_score_distribution'],
      'latest_partner_stats',
      'health_score_distribution',
      i18n.t('healthSummary.breakdown.myNetwork'),
    );

    const combined: healthScoreCombined[] = combineHealthChart(
      partnerStatsSeries,
      typicalStatsSeries,
    );
    return combined;
  }
  console.error('SIGNAL INTERNAL: Unable to parse health score data');
  return [];
};
